import { render, staticRenderFns } from "./t-gallery.vue?vue&type=template&id=0f0dfa99&"
import script from "./t-gallery.vue?vue&type=script&lang=js&"
export * from "./t-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports